var map = {
	"./add.svg": 55338,
	"./amex.svg": 32564,
	"./arrow-down.svg": 87059,
	"./arrow-left-white.svg": 34837,
	"./arrow-left.svg": 3418,
	"./arrow-right-m.svg": 2471,
	"./arrow-right-white.svg": 96720,
	"./arrow-right.svg": 5415,
	"./arrow-up.svg": 62808,
	"./arrow_back.svg": 83246,
	"./arrow_backward_ios.svg": 23510,
	"./arrow_forward_ios.svg": 42488,
	"./bag-new.svg": 48216,
	"./bag.svg": 60411,
	"./big-simple-arrow-down.svg": 44209,
	"./big-simple-arrow-left.svg": 44705,
	"./big-simple-arrow-right.svg": 80645,
	"./big-simple-arrow-up.svg": 14899,
	"./blog.svg": 22341,
	"./check-black.svg": 18601,
	"./check-round.svg": 1600,
	"./check-splash.svg": 78605,
	"./check.svg": 64994,
	"./checkmark-filled-black.svg": 56688,
	"./checkmark-filled-green.svg": 98217,
	"./checkmark-filled.svg": 47256,
	"./checkmark.svg": 64775,
	"./close-white.svg": 72701,
	"./close.svg": 94755,
	"./color-spray-1.svg": 60483,
	"./contact.svg": 33253,
	"./credit_card.svg": 10125,
	"./cross-gray.svg": 15786,
	"./cross-regular.svg": 46255,
	"./cross.svg": 73750,
	"./facebook.svg": 78528,
	"./flag-1.svg": 48229,
	"./flag.svg": 83792,
	"./globe.svg": 94489,
	"./instagram.svg": 74443,
	"./keyboard_arrow_down.svg": 92316,
	"./klarna-pink.svg": 81660,
	"./klarna.svg": 71336,
	"./line.svg": 82070,
	"./lock.svg": 5523,
	"./love.svg": 93156,
	"./mall-simple-arrow-up.svg": 54475,
	"./mastercard.svg": 64885,
	"./medical-specialty-skin-1.svg": 78904,
	"./menu.svg": 57859,
	"./minus.svg": 51225,
	"./nav.svg": 9753,
	"./offers.svg": 10655,
	"./pink-klarna.svg": 44557,
	"./plant-1.svg": 57269,
	"./plus-white.svg": 4891,
	"./plus.svg": 19851,
	"./polygon.svg": 31438,
	"./question.svg": 33011,
	"./remove.svg": 52711,
	"./reviewStar.svg": 58254,
	"./search.svg": 83225,
	"./small-simple-arrow-down.svg": 55461,
	"./small-simple-arrow-left.svg": 84376,
	"./small-simple-arrow-right.svg": 69892,
	"./spray.svg": 54951,
	"./star.svg": 53527,
	"./star_black.svg": 86790,
	"./star_black_outline.svg": 61608,
	"./stars.svg": 12482,
	"./starsblack.svg": 98120,
	"./sunbed.svg": 17881,
	"./tanrevel-black.svg": 46914,
	"./tanrevel.svg": 71091,
	"./tiktok.svg": 16387,
	"./trash-white.svg": 59125,
	"./trash.svg": 5499,
	"./truck.svg": 83294,
	"./visa.svg": 45038,
	"./white-cross.svg": 82227,
	"./youtube.svg": 62275
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87254;